import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ToastKind = 'info' | 'success' | 'warning' | 'error';

export interface Toast {
  id: number;
  text: string;
  kind: ToastKind;
}

/** Длительность показа: ошибки висят дольше — их надо успеть прочитать. */
const DURATION: Record<ToastKind, number> = { info: 3000, success: 3000, warning: 5000, error: 6500 };

export const useToastStore = defineStore('toast', () => {
  const items = ref<Toast[]>([]);
  let nextId = 1;

  function dismiss(id: number) {
    items.value = items.value.filter((t) => t.id !== id);
  }

  function push(text: string, kind: ToastKind) {
    const id = nextId++;
    items.value.push({ id, text, kind });
    // Не копим бесконечную стопку при серии ошибок.
    if (items.value.length > 5) items.value.splice(0, items.value.length - 5);
    setTimeout(() => dismiss(id), DURATION[kind]);
  }

  return {
    items,
    dismiss,
    // info — исторически «успех» по всей панели (после сохранения), поэтому рисуется как success.
    info: (text: string) => push(text, 'success'),
    success: (text: string) => push(text, 'success'),
    warning: (text: string) => push(text, 'warning'),
    error: (text: string) => push(text, 'error'),
  };
});
